import React from 'react';

// Official-style Nutri-Score colours
const COLORS = {
  A: '#038141', B: '#85BB2F', C: '#FECB02', D: '#EF8200', E: '#E63E11',
};

export default function NutriScore({ score, size = 34, showLabel = false, label }) {
  if (!score) return null;
  const s = String(score).toUpperCase();
  const bg = COLORS[s] || '#85BB2F';
  const dark = s === 'C';
  return (
    <div className="flex items-center gap-2">
      {showLabel && (
        <span className="text-[10px] font-semibold uppercase tracking-wide text-white/90 bg-black/35 px-2 py-1 rounded-full">
          {label}
        </span>
      )}
      <span
        className="inline-flex items-center justify-center rounded-full font-extrabold shadow-sm"
        style={{ width: size, height: size, background: bg, color: dark ? '#3a2e00' : '#fff', fontSize: size * 0.5 }}
        aria-label={`Nutri-Score ${s}`}
      >
        {s}
      </span>
    </div>
  );
}
